import { render } from "./PushBanner.vue?vue&type=template&id=ffc8aa30&scoped=true"
import script from "./PushBanner.vue?vue&type=script&lang=js"
export * from "./PushBanner.vue?vue&type=script&lang=js"

import "./PushBanner.vue?vue&type=style&index=0&id=ffc8aa30&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc8aa30"]])

export default __exports__